<template>
  <div :class="className || ''">
    <div :class="`description-more ${showToggle ? 'faded-bottom' : ''} ${expanded ? 'off' : ''}`">
      <slot></slot>
    </div>
    <div v-if="showToggle">
      <b-button variant="link" size="sm" class="p-0 text-muted" @click="onClick">
        {{ expanded ? trans('hide') : (trans('more')+'...') }}
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      className: String,
      words: Number,
      text: String,
    },
    data() {
      return {
        trans: trans,
        expanded: false,
      }
    },
    computed: {
        showToggle(){
            if (!this.words || !this.text) {
                return true
            }

            return this.words && this.text.trim().length > this.words
        }
    },
    methods: {
      onClick(e) {
        e.preventDefault()
        e.stopPropagation()
        if (this.expanded) {
          this.expanded = false
        } else {
          this.expanded = true
        }
      },
    },
    mounted() {
    },
  }
</script>
